<template>
  <b-card class="mt-2">
    <template #header>
      <div class="row d-flex justify-content-between align-items-center">
        <div class="col-auto">
          Lista
          <b-badge variant="success" class="mr-2">{{ labelHeader }}</b-badge>
        </div>

        <div class="col-auto">
          <h5>
            {{
              'Valor Minimo do Pedido: ' +
              format(this.valorMinimoPedido, config)
            }}
          </h5>
        </div>

        <div class="col-auto">
          <h5>
            {{
              this.valorMinimoParcela > 0
                ? 'Valor Minimo da Parcela: ' +
                  format(this.valorMinimoParcela, config)
                : '-'
            }}
          </h5>
        </div>

        <div class="col-auto">
          <h5
            :class="{
              'text-danger': !this.valorMinimoAtingido,
              'text-success': this.valorMinimoAtingido,
            }"
          >
            {{ 'Total: ' + format(this.valorTotal, config) }}
          </h5>
        </div>

        <div class="col-auto" v-if="this.show_mais_farmacias">
          <b-button
            class="ml-2"
            :class="{
              'bg-danger': this.coresBotaoSubpedidos.vermelho,
              'bg-success': this.coresBotaoSubpedidos.verde,
              'bg-secondary': this.coresBotaoSubpedidos.cinza,
            }"
            @click="abreListaFarmacias()"
            >Compras + Farmácias</b-button
          >
        </div>
      </div>
    </template>
    <OverlayPanel
      v-if="fieldsFilter.length > 0"
      ref="op"
      :showCloseIcon="true"
      :dismissable="true"
      :style="widthFilter ? { width: widthFilter } : { width: '450px' }"
    >
      <FilterDefault
        :key="key"
        :fieldsInput="fieldsFilter"
        :labelHeader="labelHeader"
        :table="table"
        :item="filter"
      ></FilterDefault>
    </OverlayPanel>

    <Sidebar v-model:visible="show_menu" position="full" class="p-sidebar-sm">
      <ListFarmacias
        :key="produto.id"
        @onChangeForm="onChangeForm"
        @onChangeCloseModal="
          show_menu ? (show_menu = false) : (show_menu = true)
        "
        @gravaPedidos="gravaPedidos"
        @updateQuantidade="updateQuantidade"
        @decideCorMaisFarmacias="decideCorMaisFarmacias"
        :pedidoPrincipalInfo="this.pedidoPrincipalInfo"
        :positionModal="center"
      ></ListFarmacias>
    </Sidebar>

    <div :key="key">
      <b-overlay :show="show_overlay" rounded="sm">
        <DataTable
          :value="list"
          class="p-datatable-sm"
          responsiveLayout="scroll"
          selectionMode="single"
          dataKey="id"
          sortMode="multiple"
          :multiSortMeta="multiSortMeta"
          :rowClass="rowClass"
        >
          <Column field="cean" header="EAN" :sortable="true">
            <template #body="item">
              <div class="mr-2">
                {{ item.data.cean }}
              </div>
            </template>
          </Column>
          <Column field="descricao" header="Descrição" :sortable="true">
            <template #body="item">
              <div class="mr-2">
                {{ item.data.descricao }}
              </div>
            </template>
          </Column>
          <Column field="laboratorio" header="Indústria" :sortable="true">
            <template #body="item">
              <div class="mr-2">
                {{ item.data.laboratorio }}
              </div>
            </template>
          </Column>
          <Column
            field="compra_obrigatorio"
            header="Obrigatório?"
            class="text-center"
            :sortable="true"
          >
            <template #body="item">
              <div>
                {{ item.data.compra_obrigatorio == 'S' ? 'Sim' : 'Não' }}
              </div>
            </template>
          </Column>
          <Column
            field="quant_minima"
            header="Quantidade Mínima"
            class="text-center"
            :sortable="true"
          >
            <template #body="item">
              <div>
                {{ parseInt(item.data.quant_minima) }}
              </div>
            </template>
          </Column>
          <Column
            field="valor_unitario"
            header="Valor Unitário"
            class="text-center"
            :sortable="true"
          >
            <template #body="item">
              <div>
                {{ format(parseFloat(item.data.valor_unitario), config) }}
              </div>
            </template>
          </Column>
          <Column
            header="Qtde"
            field="qtde"
            :style="{
              width: '100px',
              position: 'relative',
            }"
          >
            <template #body="item">
              <b-form-group>
                <b-form-input
                  :id="`${item.data.id}`"
                  type="number"
                  min="0"
                  max=""
                  class="input-qtde"
                  v-model="item.data.quant_solicitada"
                  @input="(v) => updateQuantidade(v, item)"
                ></b-form-input>
              </b-form-group>
            </template>
          </Column>

          <Column header="Total" class="text-center">
            <template #body="item">
              <div>
                {{
                  format(
                    parseFloat(
                      item.data.valor_unitario * item.data.quant_solicitada,
                    ),
                    config,
                  )
                }}
              </div>
            </template>
          </Column>
        </DataTable>
      </b-overlay>
    </div>
  </b-card>
</template>

<script>
import { useRoute } from 'vue-router'
import service from '@/services/BaseService'
import ListFarmacias from '@/views/hiperfarma_campanhas/pedido/ListFarmacias.vue'

// import qs from 'qs'
import { format } from 'v-money3'
import config from '@/functions/formatMoney'
export default {
  props: ['valorMinimoParcela', 'pedidoPrincipalInfo'],
  components: { ListFarmacias },
  setup() {
    const route = useRoute()
    return {
      route: route,
    }
  },
  data() {
    return {
      format: format,
      config: config,
      valorMinimoAtingido: false,
      valorMinimoPedido: 0,
      valorTotal: 0,
      coresBotaoSubpedidos: {},
      color: ['orange', 'green'],
      qtdeProduto: null,
      table: 'CAM_CAMPANHA_PRODUTO',
      labelHeader: 'Produto',
      positionModal: 'center',
      widthFilter: '30',
      key: 0,
      produto: {},
      flagLock: false,
      show_menu: false,
      show_overlay: false,
      show_mais_farmacias: false,
      visible: false,
      dados_pedido: {},
      list: [],
      item: {},
      fieldsFilter: [],
      filter: {},
    }
  },
  created() {
    this.verificaPedidoFarmacia()
    this.calculaValorMinimo()
    this.calculaValorTotal()

    this.valorMinimoAtingido = this.valorTotal >= this.valorMinimoPedido
    this.getList()
  },
  mounted() {
    this.emitter.on('modal-filter', (event) => {
      this.$refs.op.toggle(event)
    })
    this.emitter.on('update-filter', (event) => {
      this.filter = event[1]
      this.$refs.op.toggle(event[0])
      this.getList()
    })
  },
  beforeUnmount() {
    this.emitter.off('modal-filter')
    this.emitter.off('update-filter')
  },
  methods: {
    gravaPedidos() {
      this.$emit('gravaPedidos')
    },
    decideCorMaisFarmacias() {
      const subpedidos = this.$store.getters['multiplosPedidos']
      var subpedidosValidos = true
      if (subpedidos.length > 0) {
        for (let i = 0; i < subpedidos.length; i++) {
          if (!subpedidos[i].ehValido && subpedidos[i].fazer_pedido) {
            subpedidosValidos = false
            break
          }
        }
      } else {
        this.coresBotaoSubpedidos.cinza = true
        this.coresBotaoSubpedidos.vermelho = false
        this.coresBotaoSubpedidos.verde = false
      }

      if (subpedidosValidos) {
        this.coresBotaoSubpedidos.cinza = false
        this.coresBotaoSubpedidos.vermelho = false
        this.coresBotaoSubpedidos.verde = true
      } else {
        this.coresBotaoSubpedidos.cinza = false
        this.coresBotaoSubpedidos.vermelho = true
        this.coresBotaoSubpedidos.verde = false
      }

      return subpedidosValidos
    },
    async verificaPedidoFarmacia() {
      var pedido = {}
      const farmaciaId = this.$store.getters['pedidoInfo'].farmacia_id
      const campanhaId = this.$store.getters['pedidoInfo'].campanha_id
      var http = new service(
        `default/CAM_PEDIDO/search/params?cam_campanha_id=${campanhaId}&farmacia_id=${farmaciaId}`,
      )
      await http.find().then((res) => {
        pedido = res.data.response[0]
      })

      if (!pedido) {
        this.show_mais_farmacias = true
      }
    },
    async getList() {
      this.show_overlay = true
      const campanhaId = this.$store.getters['pedidoInfo'].campanha_id
      const pedidoId = this.$store.getters['pedidoInfo'].pedido_id
      var http = new service(
        `default/CAM_CAMPANHA_PRODUTO/search/params?cam_campanha_id=${campanhaId}&limit=999&sort=descricao`,
      )
      await http
        .find()
        .then((resp) => {
          this.list = resp.data.response.map((item) => {
            delete item.id
            delete item.created_user
            delete item.created_at
            return { ...item, quant_solicitada: 0 }
          })
          if (pedidoId) {
            this.getListProdutosPedido()
          }

          this.list.sort((a, b) => {
            if (a.descricao < b.descricao) {
              return -1
            }
            if (a.descricao > b.descricao) {
              return 1
            }
            return 0
          })

          this.calculaValorMinimo()
          this.calculaValorTotal()

          this.$emit('atualizaListaProdutos', this.list)
          this.show_overlay = false
          // this.key++
        })
        .catch(() => {
          this.show_overlay = false
          // this.key++
        })
    },

    async getListProdutosPedido() {
      this.show_overlay = true
      const pedidoID = this.$store.getters['pedidoInfo'].pedido_id
      var http = new service(
        `default/CAM_PEDIDO_PRODUTO/search/params?cam_pedido_id=${pedidoID}`,
      )
      await http
        .find()
        .then((resp) => {
          var produtos_cadastrados = resp.data.response
          produtos_cadastrados.forEach((element) => {
            this.list.forEach((list) => {
              if (list.cean == element.cean) {
                list.quant_solicitada = parseInt(element.quant_solicitada)
                list.id = element.id
              }
            })
          })
          this.$emit('atualizaListaProdutos', this.list)
          this.calculaValorTotal()
          this.$emit('atualizaValorTotal', this.valorTotal)
          this.show_overlay = false
          // this.key++
        })
        .catch(() => {
          this.show_overlay = false
          // this.key++
        })
    },

    onChangeForm() {
      this.getList()
      this.visible ? (this.visible = false) : (this.visible = true)
    },

    rowClass(item) {
      if (item.compra_obrigatorio == 'S') {
        if (parseInt(item.quant_minima) > 0) {
          if (parseInt(item.quant_solicitada) >= parseInt(item.quant_minima)) {
            return 'green-line'
          } else {
            return 'orange-line'
          }
        } else {
          return null
        }
      } else {
        if (
          parseInt(item.quant_solicitada) > 0 &&
          parseInt(item.quant_solicitada) >= parseInt(item.quant_minima)
        ) {
          return 'green-line'
        } else if (
          parseInt(item.quant_minima) > parseInt(item.quant_solicitada) &&
          parseInt(item.quant_minima) > 0 &&
          parseInt(item.quant_solicitada) > 0
        ) {
          return 'orange-line'
        } else {
          return null
        }
      }
    },

    updateQuantidade(quant_solicitada, item) {
      const index = this.list.findIndex((x) => x.cean == item.data.cean)
      this.list[index].quant_solicitada = quant_solicitada
      //this.list[item.index].quant_solicitada = quant_solicitada
      this.calculaValorTotal()
      this.$emit('atualizaListaProdutos', this.list)
      this.valorMinimoAtingido = this.valorTotal >= this.valorMinimoPedido
    },

    async calculaValorMinimo() {
      const campanhaId = this.$store.getters['pedidoInfo'].campanha_id
      const http = new service(
        `default/CAM_CAMPANHA/search/params?id=${campanhaId}`,
      )
      await http.find().then((resp) => {
        this.valorMinimoPedido = resp.data.response[0].valor_minimo
      })
    },

    calculaValorTotal() {
      this.valorTotal = 0
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].quant_solicitada) {
          var valorUnitario = parseFloat(this.list[i].valor_unitario)
          var quant_solicitada = parseInt(this.list[i].quant_solicitada)
          this.valorTotal += valorUnitario * quant_solicitada
        }
      }
      this.$emit('atualizaTotalPedido', this.valorTotal)
      this.$emit('atualizaListaProdutos', this.list)
    },

    async abreListaFarmacias() {
      //const listaPedidos = this.$store.getters['multiplosPedidos']

      if (!this.flagLock) {
        this.show_overlay = true
        var farmaciaPrincipal = {}
        var listaPedidosInfos = []
        const farmaciaID = this.pedidoPrincipalInfo.farmacia_id
        const httpFarmacia = new service(
          `default/FIN_CLIENTE/search/params?id=${farmaciaID}`,
        )
        await httpFarmacia.find().then((resp) => {
          farmaciaPrincipal = resp.data.response[0]
        })
        if (farmaciaPrincipal.email) {
          const condPgtoId = this.pedidoPrincipalInfo.cam_cond_pgto_id
          const http = new service(
            `default/FIN_CLIENTE/search/params?&email=${farmaciaPrincipal.email}&diff_classe=03`,
          )
          await http
            .find()
            .then((resp) => {
              listaPedidosInfos = resp.data.response.map((farmacia) => {
                return {
                  mensagem: '',
                  id: farmacia.id,
                  uf: farmacia.uf,
                  ehValido: false,
                  fazer_pedido: true,
                  nome: farmacia.nome,
                  email: farmacia.email,
                  condPgtoId: condPgtoId,
                  cnpjcpf: farmacia.cnpjcpf,
                  endereco: farmacia.endereco,
                  nomereduzido: farmacia.nomereduzido,
                  produtosPedido: JSON.parse(JSON.stringify(this.list)),
                }
              })
            })
            .catch((error) => {
              console.log(error)
            })

          listaPedidosInfos = listaPedidosInfos.filter(
            (farmacia) => farmacia.id != farmaciaPrincipal.id,
          )

          this.$store.commit({
            type: 'setMultiplosPedidos',
            value: listaPedidosInfos,
          })

          this.flagLock = true
          this.show_overlay = false
          this.show_menu = true
        } else {
          this.$toast.warning(
            'Essa farmácia não possui email. Não foi possível associar outras farmácias para multiplos pedidos!',
          )
        }
      } else {
        this.show_menu = true
      }
    },
  },
}
</script>
<style>
.input-qtde {
  position: relative;
  top: 7px;
}

.p-datatable.p-datatable-sm .p-datatable-tbody > tr > td {
  padding: 0rem !important;
}

.orange-line {
  background-color: #eab676 !important;
  padding: 0rem 0.5rem !important;
}

.green-line {
  background-color: #76eab6 !important;
  padding: 0rem 0.5rem !important;
}
</style>
